import { render } from "./SelectedFeatureFooter.vue?vue&type=template&id=649134a0&scoped=true&ts=true"
import script from "./SelectedFeatureFooter.vue?vue&type=script&lang=ts"
export * from "./SelectedFeatureFooter.vue?vue&type=script&lang=ts"

import "./SelectedFeatureFooter.vue?vue&type=style&index=0&id=649134a0&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649134a0"]])

export default __exports__